import React from 'react'

import { Button, InputGroup, InputGroupAddon, Input } from "reactstrap"
import TooltipItem from "components/Varios/Tooltip.js";

type PropsDownloadIcon = {
    src: string,
    showTooltips: boolean,
    titleTooltips?: string,
    id: string,
    placeholder: string
    fetchFromApi?: boolean
    disabled?:boolean
    name?:string
    className?:string
}




export default function DownloadIcon(props: PropsDownloadIcon) {

    const HandleClick = (e) => {
        e.preventDefault();
        let name = e.target.dataset.name;
        let url = props.src;

        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = props.name??"Documento.pdf";
                    a.click();
                });
            });
    }

    const isdisabled= props.disabled !== undefined && props.disabled === true;
    const classDisabled = isdisabled? "fas fa-download i-disabled" : "fas fa-download hover"

    return (
        <React.Fragment>
            <InputGroup className={props.className}>


                <Input disabled placeholder={props.placeholder} />

                <InputGroupAddon    addonType="append" style={{ backgroundColor: "#FFC200" }}>

                    {
                        !props.fetchFromApi &&
                        <a href={props.src} target="_blank" >
                            <i id={props.id} style={{ color: "white" }} className="fas fa-download" aria-hidden="true" />

                        </a>
                    }
                    {
                        props.fetchFromApi !== undefined && props.fetchFromApi === true && !isdisabled &&
                        <span onClick={(e) => HandleClick(e)}>
                            <i id={props.id} style={{ color: "white" }} className={classDisabled} aria-hidden="true" />

                        </span>
                    }
                    {
                        props.fetchFromApi !== undefined && props.fetchFromApi === true && isdisabled &&
                        <span >
                            <i id={props.id} style={{ color: "white" }} className={classDisabled} aria-hidden="true" />

                        </span>
                    }

                </InputGroupAddon>
            </InputGroup>

            {
                props.showTooltips && !isdisabled && <TooltipItem content={`Descargar ${props.titleTooltips ? props.titleTooltips : ""} `} id={props.id} />

            }
        </React.Fragment>


    )
}
